import constant from '../constants/constant'
const axios = require('axios')

const makeRequestHeader = () => {
	const access_token = localStorage.getItem('access_token')
	let headers = {}
	if( access_token ) {
		headers['Authorization'] = 'Bearer '+access_token
	}
	return headers
}

const get = async (uri, params) => {
	const headers = makeRequestHeader()
	const response = await axios.get(constant.BACKEND_DOMAIN+uri, {headers, params})
	return response.data	
}

const post = async (uri, data, params) => {
	const headers = makeRequestHeader()
	const response = await axios.post(constant.BACKEND_DOMAIN+uri, data, {headers, params})
	return response.data	
}

const formPost = async (uri, formData) => {
	const headers = makeRequestHeader()
	headers['Content-Type'] = 'multipart/form-data'
	const response = await axios.post(constant.BACKEND_DOMAIN+uri, formData, {headers})
	return response.data	
}

const _delete = async (uri, params) => {
	const headers = makeRequestHeader()
	const response = await axios.delete(constant.BACKEND_DOMAIN+uri, {headers, params})
	return response.data	
}

export default {
	get,
	post,
	formPost,
	_delete,
}